<mat-card *ngIf="isAuthenticated$ | async">
  <form [formGroup]="postFormGroup" novalidate>

    <!-- Conditional Field for Blog Posts -->
    <div class="cp-title" *ngIf="(postFormState$ | async)?.showTitle">
      <mat-form-field appearance="standard" class="cp-full-width">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" autocomplete="off">
        <mat-hint *ngIf="postFormGroup?.get('title').dirty">
          {{postFormGroup?.get('title')?.value | characterCount: 60}} Characters remaining
        </mat-hint>
      </mat-form-field>
    </div>

    <input type="file" (change)="onFileSelect($event)" accept="image/*" #fileUpload style="display: none;">
    <input type="file" ng2FileSelect [uploader]="uploader" accept=".ts, .mp4, .mkv, .wmv, .webm" style="display: none;"
      #videoUploader />

    <div class="d-flex justify-content cp-area">
      <!-- Profile Picture -->
      <div class="cp-mobile">
        <img [src]="(me$ | async)?.profileData?.photoURL?.trim() || './assets/images/profile.jpg'" alt="avatar"
          class="cp-header-image">
      </div>


      <!-- Create Post Form Field -->
      <div class="cp-full-width">
        <div *ngIf="(postFormState$ | async)?.showBody" class="d-flex flex-column">

          <!--          <div class="hint" *ngIf="postFormGroup?.get('body').dirty">-->
          <!--            {{postFormGroup?.get('body')?.value | characterCount: 200}} Characters remaining-->
          <!--          </div>-->

          <mat-form-field>
            <mat-label>Say something</mat-label>
            <mat-post-input formControlName="body" placeholder=""></mat-post-input>

            <mat-error *ngIf="postFormGroup?.get('body').hasError('required')">
              Please write something
            </mat-error>

            <mat-error *ngIf="postFormGroup?.get('body').hasError('minPost')">
              Please write more than 5 characters
            </mat-error>

            <mat-error *ngIf="postFormGroup?.get('body').hasError('maxPost')">
              Your characters are more than 280, consider writing a blog post
            </mat-error>
            <mat-hint *ngIf="postFormGroup?.get('body').dirty">
              {{postFormGroup?.get('body')?.value | characterCount: 287}} Characters remaining
            </mat-hint>
          </mat-form-field>
        </div>


        <!-- Create Post Form Field -->
        <div *ngIf="(postFormState$ | async)?.showArticleBody">
          <mat-form-field>
            <mat-label>Write your blog post</mat-label>
            <mat-article-input formControlName="articleBody"></mat-article-input>

            <mat-error *ngIf="postFormGroup.get('articleBody').hasError('required')">
              Please write something
            </mat-error>
            <mat-error *ngIf="postFormGroup.get('articleBody').hasError('minPost')">
              A blog post must have more than 280 characters
            </mat-error>
            <!-- <mat-hint *ngIf="postFormGroup?.get('articleBody').dirty">
              {{postFormGroup?.get('articleBody | characterCount')?.value}} Characters
            </mat-hint> -->
          </mat-form-field>
        </div>

        <!-- Poll Form -->
        <div class="cp-poll" *ngIf="(postFormState$ | async)?.showPoll">
          <mat-form-field appearance="standard" class="cp-full-width">
            <mat-label>Ask your question?</mat-label>
            <input matInput autocomplete="off" formControlName="question">

            <mat-error *ngIf="postFormGroup.get('question').hasError('required')">
              Please provide a question.
            </mat-error>
            <mat-error *ngIf="postFormGroup.get('question').hasError('minlength')">
              Minimum length is 5 letters
            </mat-error>
            <mat-error *ngIf="postFormGroup.get('question').hasError('maxlength')">
              Maximum length is 200
            </mat-error>
          </mat-form-field>

          <!--          <mat-form-field appearance="outline" class="poll-option1">-->
          <!--            <mat-label>Option 1</mat-label>-->
          <!--            <input matInput autocomplete="off">-->
          <!--          </mat-form-field>-->

          <div *ngFor="let answer of answers.controls; index as i">
            <div class="d-flex justify-content">
              <mat-form-field appearance="outline" class="cp-full-width">
                <mat-label>Option {{i + 1}} </mat-label>
                <input matInput [formControl]="answer" autocomplete="off">

                <mat-hint *ngIf="i > 1">An optional answer</mat-hint>
                <mat-error *ngIf="answer.hasError('required')">This option is required</mat-error>
              </mat-form-field>

              <button type="button" mat-icon-button color="primary" class="poll-add-option"
                matTooltip="Add Another Option" (click)="addOptionalAnswer()" *ngIf="(answers.controls.length - 1 === i)
                       && (answers.controls.length < 4)">
                <mat-icon>add</mat-icon>
              </button>
            </div>

            <!-- The Button Commented Below  Should Show on Option 3 after it has been added -->

            <!-- <button mat-icon-button color="accent" matTooltip="Remove Option">
            <mat-icon>remove</mat-icon>
          </button> -->
          </div>

          <div class="d-flex justify-content-center">
            <mat-form-field class="poll-full-width">
              <mat-label>Days</mat-label>
              <mat-select formControlName="dayDuration">
                <mat-option *ngFor="let day of days" [value]="day.value">
                  {{day.viewValue}}
                </mat-option>
              </mat-select>

              <mat-error>Select any duration</mat-error>
            </mat-form-field>

            <mat-form-field class="poll-full-width">
              <mat-label>Hours</mat-label>
              <mat-select formControlName="hourDuration">
                <mat-option *ngFor="let hour of hours" [value]="hour.value">
                  {{hour.viewValue}}
                </mat-option>
              </mat-select>

              <mat-error>Select any duration</mat-error>
            </mat-form-field>

            <mat-form-field class="poll-full-width">
              <mat-label>Minutes</mat-label>
              <mat-select formControlName="minuteDuration">
                <mat-option *ngFor="let minute of minutes" [value]="minute.value">
                  {{minute.viewValue}}
                </mat-option>
              </mat-select>

              <mat-error>Select any duration</mat-error>
            </mat-form-field>

          </div>
        </div>

        <!-- display images -->
        <div class="d-flex flex-wrap justify-content-center">
          <div *ngFor="let mg of (postFormState$ | async).uploadFiles; let i = index">
            <img [src]="mg.path" class="img-fluid m-1 center-cropped" width="250px" height="auto" />
            <mat-progress-bar mode="indeterminate" *ngIf="mg?.loading"></mat-progress-bar>
            <div class="d-flex justify-content-center">
              <button type="button" mat-icon-button color="warn" matTooltip="Remove" (click)="removeImage(i)">
                <mat-icon>delete_forever</mat-icon>
              </button>
            </div>
          </div>

          <!--          display videos icons-->
          <div *ngFor="let video of (postFormState$ | async).uploadVideos; let i = index">
            <img src="./assets/images/profile.jpg" class="img-fluid m-1 center-cropped" width="250px" height="auto"
              *ngIf="video?.status !== 200" />
            <div class="vg-size" *ngIf="video?.status === 200">
              <vg-player>
                <video #media [vgMedia]="media" id="singleVideo" preload="auto" controls>
                  <source [src]="video?.data?.secure_url" type="video/mp4">
                </video>
              </vg-player>
            </div>
            <mat-progress-bar mode="determinate" [value]="video?.progress" *ngIf="video?.status !== 200">
            </mat-progress-bar>
            <div class="d-flex justify-content-center">
              <button type="button" mat-icon-button color="warn" matTooltip="Remove" (click)="removeUploadVideo(video)">
                <mat-icon>delete_forever</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </form>

  <div class="d-flex justify-content-between ">
    <!-- Add Media Icons -->
    <div class="align-self-center">
      <button (click)="fileUpload.click()" type="button" mat-icon-button color="primary" matTooltip="Add Media"
        [hidden]="(postFormState$ | async).uploadFiles.length >= 4
               || !(postFormState$ | async).allowUpload">
        <mat-icon>add_photo_alternate</mat-icon>
      </button>

      <button type="button" mat-icon-button color="accent" matTooltip="Add Video" (click)="videoUploader.click()">
        <mat-icon>video_library</mat-icon>
      </button>

      <!-- <button type="button" mat-icon-button color="warn" matTooltip="Add Document">
        <mat-icon>picture_as_pdf</mat-icon>
      </button> -->
      <button type="button" mat-icon-button matTooltip="Scribe" [hidden]="postFormType === 'POST'"
        (click)="createPost()">
        <mat-icon>edit</mat-icon>
      </button>
      <button type="button" mat-icon-button matTooltip="Blog" [hidden]="postFormType === 'ARTICLE'"
        (click)="createArticle()">
        <mat-icon>receipt_long</mat-icon>
      </button>
      <button type="button" mat-icon-button color="accent" matTooltip="Add Poll" [hidden]="postFormType === 'POLL'"
        (click)="createPoll()">
        <mat-icon>ballot</mat-icon>
      </button>
    </div>
    <!-- Blog Categories -->
    <div *ngIf="false">
      <mat-form-field>
        <mat-label>Choose Category</mat-label>
        <mat-select>
          <mat-option *ngFor="let category of categories" [value]="category.value">
            {{category.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="align-self-center">
      <button mat-button cdkFocusInitial (click)="createArticle()" color="warn" [hidden]="postFormType === 'ARTICLE'"
        *ngIf="postFormGroup?.get('body').hasError('maxPost')">Switch to Blog
      </button>
      <button mat-button cdkFocusInitial (click)="createPost()" color="warn" [hidden]="postFormType === 'POST'"
        *ngIf="postFormGroup?.get('body').hasError('minPost')">Switch to Scribe
      </button>
    </div>
    <!-- Post/Publish Button -->
    <div class="d-flex align-items-center">
      <mat-spinner diameter="20" class="m-1" *ngIf="(newPostState$ | async).newPostLoading"></mat-spinner>
      <!-- This button takes you back to normal post from Blog Post -->
      <button type="button" mat-icon-button color="warn" matTooltip="Reset" matTooltipPosition="left"
        [disabled]="(postFormState$ | async)?.formType === 'POST'" (click)="createPost()">
        <mat-icon>settings_backup_restore</mat-icon>
      </button>

      <button mat-flat-button color="primary" (click)="createNewPost()"
        [disabled]="(newPostState$ | async).newPostLoading">
        Scribe
        <mat-icon>history_edu</mat-icon>
      </button>

    </div>
  </div>
</mat-card>